module.exports = __webpack_public_path__ + "static/media/landelijk.b2670900.jpg";